import { Box, Heading, Paragraph, Progress } from '@zillow/constellation-10';
import { printHidden, printOnly } from '../../../../styles/panda-styles';

export function CreditScoreBar({ creditScore }: { creditScore: number }) {
  return (
    <>
      <Box css={printHidden}>
        <Heading level={3} css={{ textAlign: 'center', marginTop: 'default', marginBottom: 'default' }}>
          {creditScore}
        </Heading>
        <Box css={{ paddingTop: 'tighter' }}>
          <Progress.Root aria-label="Credit score" size="md" minValue={300} maxValue={850} value={creditScore}>
            <Progress.Bar>
              {/* Always render the bar in the active (blue) color — never the green "complete" color, even at max */}
              <Progress.Range css={{ backgroundColor: 'ProgressIndicator.bar.track.bg.active' }} />
              <Progress.Track />
            </Progress.Bar>
          </Progress.Root>
        </Box>
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <Paragraph textStyle="body-sm" css={{ color: 'text.subtle' }}>
            300
          </Paragraph>
          <Paragraph textStyle="body-sm" css={{ color: 'text.subtle' }}>
            850
          </Paragraph>
        </Box>
      </Box>
      <Box css={printOnly}>
        <Heading level={3} css={{ marginTop: 'default', marginBottom: 'default' }}>
          {creditScore}
        </Heading>
      </Box>
    </>
  );
}
